<template>
  <div>
    <div style="display: flex; align-items: center; margin-bottom: 20px; margin-top: 10px; width: 100%;">
      <div style="display: flex; align-items: center; flex-grow: 1;"></div>
      <export-components v-if="!isAuditViewOnly" :apiFunction="exportInvoice" :requestData="getSearch({...sendData[activeTab]})" :option="option"
        @sendData=getSearchData></export-components>
    </div>
    <el-tabs v-model="activeTab" @tab-click="changeTab">
      <el-tab-pane v-for="(item,tabIndex) in data" :label="item.label" :name="item.name" :key="tabIndex">
        <span slot="label" v-if="item.showBadge">
          <el-badge style="margin-top: 10px;margin-bottom: 10px" :value="pageTotal[item.name] === 0 ? '':pageTotal[item.name]"
            :max="99">{{item.label}}</el-badge>
        </span>
      </el-tab-pane>
    </el-tabs>
    <w-table :columns="columns" :table-data="tableData" @rowSelection="rowSelection($event)" :key="activeTab"
      @getTableSearchSortCon="(...event) => { getTableSearchSortCon(event) }" :isPagination="true"
      :table-col-check="{isShow:true,name:'Refund_Check4' + activeTab}" :isShowRowSelection="true"
      ref="wMyTable" :page="page" @pageChange="handlePagePagination">
      <div slot="operation" slot-scope="{text,record}">
        <el-button size="mini" type="primary" v-if="record.refundAuditStatus === 'APPLYING' && !isAuditViewOnly"
          @click="handleEdit(record)">审核</el-button>
        <el-button size="mini" type="success" v-if="isAuditViewOnly"
          @click="handleDetails(record)">查看详情</el-button>
        <el-button size="mini" style="color:#ffffff;background-color: #779221"
          v-if="record.refundAuditStatus !== 'APPLYING'&&record.appendix" icon="el-icon-download"
          @click="download(record)">下载发票</el-button>
      </div>
      <div slot="contactName" style="display:flex" slot-scope="{text,record,index}">
        <ex-fold-table-cell :scope="{text:[...new Set(text)], record, index}"></ex-fold-table-cell>
      </div>
      <div slot="connectedFlag" slot-scope="{text,record}">
        <div v-if="record['requestNumberOfInvoices']>1">
          <el-tag v-if="text === 1" type="success">是</el-tag>
          <el-tag v-else-if="text === 0" type="danger">否</el-tag>
          <el-tag v-else type="primary">未知状态</el-tag>
        </div>
        <div v-else>
          <el-tag type="info">NA</el-tag>
        </div>
      </div>
      <div slot="sameDayFlag" slot-scope="{text,record}">
        <div v-if="record['requestNumberOfInvoices']>1">
          <el-tag v-if="text === 1" type="success">是</el-tag>
          <el-tag v-else-if="text === 0" type="danger">否</el-tag>
          <el-tag v-else type="primary">未知状态</el-tag>
        </div>
        <div v-else>
          <el-tag type="info">NA</el-tag>
        </div>
      </div>
      <div slot="refundAuditStatus" slot-scope="{text,record}">
        <span style="display: flex;align-items: center">
          <el-tag :type="getStatusColor(text,'tagType')"
            :style="{color: getStatusColor(text,'color'),'background-color':getStatusColor(text,'backgroundColor')}">
            {{getStatusColor(text,'name')}}</el-tag>
          <w-ellipsis-and-look v-if="text === 'DEFEAT'" style="margin-left:5px" class="w-ellipsis-and-look"
            :text="record['rejectionReason']" :column="{title:'驳回原因'}" :onlyDetail="true" :isOpenHtml="false">
          </w-ellipsis-and-look>
        </span>
      </div>
      <div slot="invoiceStatus" slot-scope="{text,record}">
        <el-tag :type="getInvoiceColor(text,'tagType')"
          :style="{color: getInvoiceColor(text,'color'),'background-color':getInvoiceColor(text,'backgroundColor')}">
          {{getInvoiceColor(text,'name')}}</el-tag>
      </div>
      <div slot="contractNumbers" slot-scope="{text,record,index}">
        <ex-fold-table-cell v-if="text" :scope="{text, record, index}"></ex-fold-table-cell>
      </div>
      <div slot="filterInvoice" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='应收款'>应收款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='待开票'>待开票</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已回款'>已回款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='待退票'>待退票</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='退票成功'>退票成功</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='部分到款'>部分到款</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='取消开票'>取消开票</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索</a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消</a-button>
        </div>
      </div>
      <div slot="filterStatus" slot-scope="{ setSelectedKeys, selectedKeys, confirm, column,clearFilters  }"
        style="padding: 8px; position: relative; z-index: 9999 !important;">
        <div style="padding: 15px 15px 0">
          <el-radio-group v-model="selectedKeys[0]">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='待审核'>待审核</el-radio>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-radio label='已通过'>已通过</el-radio>
              </el-col>
              <el-col :span="12">
                <el-radio label='已驳回'>已驳回</el-radio>
              </el-col>
            </el-row>
          </el-radio-group>
        </div>
        <div style="display: flex;padding: 15px">
          <a-button type="primary" icon="search" size="small" style="width: 90px; margin-right: 8px"
            @click="() => handleSearch(setSelectedKeys,selectedKeys, confirm, column,clearFilters)">搜索</a-button>
          <a-button size="small" style="width: 90px" @click="() => handleReset( column,clearFilters)">取消</a-button>
        </div>
      </div>
    </w-table>
    <picture-loading v-if="loading"></picture-loading>
    <tickets-check-dialog v-if="showCheckDialog" :show-dialog="showCheckDialog" :select-detail="selectDetail"
      :readonly="isAuditViewOnly" @submit="closeCheckDialog">
    </tickets-check-dialog>
    <customer-user-info :show-dialog="showContactInfo" v-if="showContactInfo" :select-detail="contactInfo"
      @submit="closeShowContact"></customer-user-info>
  </div>
</template>

<script>

import {attachmentTickets, exportInvoice, getTicketsPage} from "@/api/dilivery/tickets";
import TicketsCheckDialog from "@/components/check/TicketsCheckDialog.vue";
import {ticketsCheck} from "@/utils/data/tableCol/check/tickets/ticketsCheck";
import TableHeadNote from "@/components/customerTable/TableHeadNote.vue";
import ExFoldTableCell from "@/components/ExFoldTableCell.vue";
import {tableOperationMixin} from "@/mixins/tableOperation";
import PictureLoading from "@/components/customerTable/PictureLoading.vue";
import _ from "lodash";
import ExportComponents from "@/components/ExportComponents.vue";
import {getInvoiceColor, getStatusColor} from "@/color";
import {viewDetailIcon} from "@/utils/icon";
import {getUserPage} from "@/api/dilivery/customer/user";
import CustomerUserInfo from "@/components/customer/CustomerUserInfo.vue";
import { getDataInLocalStorage } from "@/utils/localStorage";
import { auditViewOnlyMixin } from "@/mixins/auditViewOnlyMixin";
const baseURL = process.env.VUE_APP_BASE_API

export default {
  name: "TicketsCheck",
  components: {CustomerUserInfo, ExportComponents, PictureLoading, TableHeadNote,ExFoldTableCell, TicketsCheckDialog},
  mixins: [tableOperationMixin, auditViewOnlyMixin],
  data() {
    return {
      tableData: [],
      selectable: [],
      searchConditionTag: [],
      sortConditionTag: [],
      page: { pageSize: 10, currentNum: 1, total: null },
      data: [
        { label: '全部', name: 'ALL', showBadge: false },
        { label: '待审核', name: 'APPLYING', showBadge: true },
        { label: '已通过', name: 'SUCCESS', showBadge: false },
        { label: '已驳回', name: 'DEFEAT', showBadge: false },
      ],
      sendData: {
        ALL: { "query#refundAuditStatus.IN": "APPLYING,SUCCESS,DEFEAT" },
        APPLYING: { "query#refundAuditStatus.EQ": "APPLYING" },
        SUCCESS: { "query#refundAuditStatus.EQ": "SUCCESS" },
        DEFEAT: { "query#refundAuditStatus.EQ": "DEFEAT" },
      },
      pageTotal: { ALL: 0, APPLYING: 0, SUCCESS: 0, DEFEAT: 0 },
      option: [
        { label: '退票申请时间', value: 'refundTime' },
        { label: '退票日期', value: 'refundDate' },
        { label: '退票审核日期', value: 'operatingTime' },
        { label: '开票日期', value: 'invoiceDate' },
        { label: '创建时间', value: 'createTime' },
      ],
      viewDetailIcon: viewDetailIcon,
      contactInfo: [],
      showContactInfo: false,
      loading: true,
      activeTab: 'APPLYING',
      showCheckDialog: false,
      selectDetail: ''
    }
  },
  computed: {
    columns() {
      return JSON.parse(JSON.stringify(ticketsCheck([] || {}))).filter(item => !['operatingPersonName','operatingTime'].includes(item.key) || this.activeTab !== "APPLYING")
    },
  },
  mounted() {
    this.loadAllTabTotals()
    this.getData()
  },
  methods: {
    getStatusColor,
    getInvoiceColor,
    exportInvoice,
    loadAllTabTotals() {
      // 销售侧角色（SALES_MANAGER、SALES）仅查看详情，不发起标签页红点数量查询
      if (this.isAuditViewOnly) return
      Object.keys(this.sendData).forEach(tabName => {
        let sendData = { ...this.sendData[tabName] }
        getTicketsPage({ 'page.current': 1, 'page.size': 1 }, sendData).then(res => {
          if (res.code === 200) {
            this.$set(this.pageTotal, tabName, parseInt(res.data.total))
          }
        })
      })
    },
    changeTab() {
      this.$nextTick(() => {
        this.tableData = []
        this.selectable = []
        this.searchConditionTag = []
        this.sortConditionTag = []
        this.page = { pageSize: 10, currentNum: 1, total: null }
        if (this.$refs.wMyTable) {
          this.$refs.wMyTable.selectedRowKeys = []
          this.$refs.wMyTable.searchConditionTag = []
        }
        this.getData()
      })
    },
    closeShowContact() {
      this.showContactInfo = false
    },
    showContact(contactName) {
      let data = { "query#contactName.IN": contactName.join(',') }
      getUserPage({}, data).then(res => {
        if (res.code === 200) {
          this.contactInfo = res.data.records
          this.showContactInfo = true
        } else {
          this.showContactInfo = false
        }
      }).catch(err => {
        this.showContactInfo = false
      })
    },
    async download(row) {
      try {
        let url = `${baseURL}/invoice-info/attachment/${row.id}?Authorization=${getDataInLocalStorage("token")}&Current-Role=${getDataInLocalStorage("role")}`
        const elink = document.createElement('a')
        elink.href = url
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink);
      } catch (error) {
        console.log(error);
      }
    },
    rowSelection(selectedRows) {
      this.selectable = _.unionBy(this.selectable, selectedRows, 'id').filter(item => this.$refs.wMyTable.selectedRowKeys.includes(item.id));
    },
    getTableSearchSortCon(ConditionTag) {
      this.searchConditionTag = ConditionTag[0]
      this.sortConditionTag = ConditionTag[1]
      this.getData('search')
    },
    handlePagePagination(page) {
      this.page.currentNum = page.currentNum
      this.page.pageSize = page.pageSize
      this.getData()
    },
    getSearchData(sendData) {
      if (sendData) {
        this.searchConditionTag = this.searchConditionTag.filter(item => !this.option.map(itemA => itemA.value).includes(item.key))
        if (Object.keys(sendData).length) {
          this.searchConditionTag.push(sendData)
        }
        this.$refs.wMyTable.searchConditionTag = this.searchConditionTag;
        this.getData('search')
      }
    },
    getData(searchFlag) {
      this.loading = true
      let params = {
        'page.current': this.page.currentNum,
        'page.size': this.page.pageSize,
      }
      if (searchFlag) {
        params = { 'page.current': 1, 'page.size': 10 }
      }
      if (this.sortConditionTag && this.sortConditionTag.length > 0) {
        params["order"] = this.sortConditionTag.map(sortCondition => {
          return sortCondition.colName + "." + sortCondition.order;
        }).join(",");
      }
      let sendData = { ...this.sendData[this.activeTab] }
      if (this.searchConditionTag && this.searchConditionTag.length) {
        sendData = this.getSearch(sendData)
      }
      getTicketsPage(params, sendData).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.tableData = res.data.records
          this.page.currentNum = parseInt(res.data.current)
          this.page.pageSize = parseInt(res.data.size)
          this.page.total = parseInt(res.data.total)
          // 销售侧角色不展示标签页红点数量
          if (!this.isAuditViewOnly) {
              this.$set(this.pageTotal, this.activeTab, parseInt(res.data.total))
          }
        }
      }).catch(error => {
        this.loading = false
      })
    },
    getSearch(sendData) {
      
      this.searchConditionTag.forEach(item => {
        let value = item.value
        if (item.key === 'refundAuditStatus') {
          if (item.value === '待审核') {
            value = 'APPLYING'
          } else if (item.value === '已通过') {
            value = 'SUCCESS'
          } else {
            value = 'DEFEAT'
          }
        } else if (item.key === 'invoiceStatus') {
          if (item.value === '待审核') {
            value = 'PENDING_AUDIT'
          } else if (item.value === '待开票') {
            value = 'PENDING_INVOICE'
          } else if (item.value === '应收款') {
            value = 'RECEIVABLES'
          } else if (item.value === '已回款') {
            value = 'PAYMENT'
          } else if (item.value === '退票成功') {
            value = 'REFUND_SUCCESS'
          } else if (item.value === '部分到款') {
            value = 'PARTIAL_ARRIVAL'
          } else if (item.value === '取消开票') {
            value = 'CANCEL_INVOICING'
          } else {
            value = 'PENDING_REFUND'
          }
        } else if (item.key === 'contractNumber') {
          value = value.replace(/[A-Za-z]/g, "")
        }
        if (['invoiceRecordNumber','statusType','contractNumber','saleName','invoicingPrincipal','invoiceTitle','billingUnitName','contactName'].includes(item.key)) {
          sendData[item.key] = value
        } else if (this.option.map(it => it.value).includes(item.key)) {
          sendData["query#" + item.key + ".BETWEEN"] = item.value
        } else {
          sendData["query#" + item.key + ".LIKE"] = value
        }
      })
      return sendData
    },
    async handleEdit(row) {
      try {
        const res = await getTicketsPage({}, { "query#id.EQ": row.id })
        if (res.code === 200 && res.data.records.length > 0) {
          if (res.data.records[0].refundAuditStatus !== 'APPLYING') {
            this.$messageUi.error('该条数据已审核')
            this.getData()
            return
          }
          this.selectDetail = { ...res.data.records[0] }
        } else {
          this.$messageUi.error('发票数据获取失败')
          return
        }
        this.showCheckDialog = true
      } catch (error) {
        console.log(error);
        this.showCheckDialog = false
        this.$messageUi.error('打开审核页面失败')
      }
    },
    closeCheckDialog(type) {
      if (type === 'confirm') {
        this.getData()
      }
      this.$nextTick(() => {
        this.showCheckDialog = false
      })
    },
    // 只读角色查看退票申请详情（复用审核弹窗，隐去审核操作区）
    handleDetails(row) {
      this.selectDetail = { ...row }
      this.showCheckDialog = true
    }
  }
}
</script>

<style scoped>

</style>
